import React from 'react';

// Hộp xác nhận quyết định của admin: lý do (10 đến 1000 ký tự) và mã Authenticator 6 số.

interface Props {
  title: string;
  description: string;
  reason: string;
  totp: string;
  busy: boolean;
  children?: React.ReactNode;
  onReason: (v: string) => void;
  onTotp: (v: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

const AdminLiveDecisionModal: React.FC<Props> = ({
  title, description, reason, totp, busy, children, onReason, onTotp, onClose, onConfirm,
}) => (
  <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
    <div
      className="max-h-[90vh] w-full max-w-[460px] overflow-y-auto rounded-2xl bg-white p-6 shadow-xl dark:bg-slate-800"
      onClick={(e) => e.stopPropagation()}
    >
      <h4 className="mb-1 text-lg font-semibold text-slate-800 dark:text-white">{title}</h4>
      <p className="mb-4 text-sm text-slate-500 dark:text-slate-300">{description}</p>
      {children}
      <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-200">
        Lý do (10 đến 1000 ký tự) <span className="text-red-500">*</span>
      </label>
      <textarea
        value={reason}
        onChange={(e) => onReason(e.target.value)}
        rows={3}
        maxLength={1000}
        className="mb-4 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#0057FF] dark:border-slate-600 dark:bg-slate-900 dark:text-white"
      />
      <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-200">
        Mã Authenticator (6 số) <span className="text-red-500">*</span>
      </label>
      <input
        value={totp}
        onChange={(e) => onTotp(e.target.value.replace(/\D/g, '').slice(0, 6))}
        placeholder="123456"
        inputMode="numeric"
        className="mb-4 w-full rounded-lg border border-gray-300 px-3 py-2 text-center text-lg tracking-[0.3em] outline-none focus:border-[#0057FF] dark:border-slate-600 dark:bg-slate-900 dark:text-white"
      />
      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="h-10 min-w-[90px] rounded-md border border-gray-300 px-4 text-sm font-medium text-slate-600 hover:bg-slate-100 dark:border-slate-600 dark:text-slate-200 dark:hover:bg-slate-700"
        >
          Huỷ
        </button>
        <button
          disabled={totp.length !== 6 || busy}
          onClick={onConfirm}
          className="h-10 min-w-[130px] rounded-md bg-green-500 px-4 text-sm font-semibold text-white hover:bg-green-600 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Xác nhận
        </button>
      </div>
    </div>
  </div>
);

export default AdminLiveDecisionModal;
